function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Schema } from 'prosemirror-model';
import { markSpecs } from './specs/mark-specs';
import { nodeSpecs } from './specs/node-specs';
export class SchemaGenerator {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    this.config = config;
  }
  schema() {
    if (this.containsMultipleListTypes()) {
      throw new Error('schema should not have both nested and non-nested lists');
    }
    return new Schema(this.schemaSpec);
  }
  containsMultipleListTypes() {
    let allowedBlocks = this.config.allowedBlocks;
    let containsFlatLists = allowedBlocks.some(b => this.isListType(b));
    let containsNestedLists = allowedBlocks.some(b => this.isNestedListType(b));
    return containsFlatLists && containsNestedLists;
  }
  get schemaSpec() {
    return {
      nodes: this.nodes,
      marks: this.marks
    };
  }
  get nodes() {
    let nodes = {
      doc: nodeSpecs.doc,
      text: nodeSpecs.text,
      hardBreak: nodeSpecs.hardBreak,
      marker: nodeSpecs.marker
    };
    if (this.config.singleBlockMode) {
      nodes.doc = nodeSpecs.singleBlockDoc;
    }
    if (this.config.templating) {
      nodes.template = nodeSpecs.template;
      nodes.template.infoResolver = this.config.templating.resolver;
    }
    if (this.config.aiPromptData) {
      nodes.aiPromptData = nodeSpecs.aiPromptData;
      nodes.aiPromptData.infoResolver = this.config.aiPromptData.resolver;
    }
    this.config.allowedBlocks.forEach(blockType => {
      if (this.isListType(blockType) && !nodes['listItem']) {
        nodes['listItem'] = nodeSpecs['listItem'];
      } else if (blockType === 'table') {
        nodes['tableRow'] = nodeSpecs['tableRow'];
        nodes['tableCell'] = nodeSpecs['tableCell'];
        if (this.config.tables.containers) {
          nodes['tableCell'] = {
            ...nodes['tableCell'],
            content: '(block | list | table)+'
          };
        }
      } else if (this.isNestedListType(blockType)) {
        nodes['nestedListItem'] = nodeSpecs['nestedListItem'];
      } else if (blockType === 'collapsibleSection') {
        nodes['collapsibleSectionSummary'] = nodeSpecs['collapsibleSectionSummary'];
        nodes['collapsibleSectionContent'] = nodeSpecs['collapsibleSectionContent'];
      } else if (blockType === 'imageText') {
        nodes['imageText'] = nodeSpecs['imageText'];
      }
      nodes[blockType] = nodeSpecs[blockType];
    });
    this.config.allowedInline.forEach(inlineType => {
      if (nodeSpecs[inlineType]) {
        nodes[inlineType] = nodeSpecs[inlineType];
      }
    });
    this.stripListIfNeeded(nodes);
    this.stripTableIfNeeded(nodes);
    return nodes;
  }
  stripListIfNeeded(nodes) {
    if (nodes['orderedList'] || nodes['unorderedList'] || nodes['orderedNestedList'] || nodes['unorderedNestedList']) {
      return;
    }
    let docContent = nodes.doc.content || '';
    let prefixListExp = /list\s*\|\s*/;
    let suffixListExp = /\s*\|\s*list/;
    let content = docContent.replace(prefixListExp, '').replace(suffixListExp, '');
    nodes.doc = {
      ...nodes.doc,
      content
    };
  }
  stripTableIfNeeded(nodes) {
    if (nodes['table']) {
      return;
    }
    let docContent = nodes.doc.content || '';
    let prefixTableExp = /table\s*\|\s*/;
    let suffixTableExp = /\s*\|\s*table/;
    let content = docContent.replace(prefixTableExp, '').replace(suffixTableExp, '');
    nodes.doc = {
      ...nodes.doc,
      content
    };
  }
  isListType(blockType) {
    return blockType === 'orderedList' || blockType === 'unorderedList';
  }
  isNestedListType(blockType) {
    return blockType === 'orderedNestedList' || blockType === 'unorderedNestedList';
  }
  get marks() {
    let marks = {};
    this.config.allowedInline.forEach(inlineType => {
      if (markSpecs[inlineType]) {
        marks[inlineType] = markSpecs[inlineType];
      }
    });
    return marks;
  }
}